export default "__VITE_ASSET__0LrBp0zT__"